import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { BasicInputTypeEnum } from '../../../enums/basic-input-type.enum';
import { IBasicInputConfig } from '../../../interfaces/basic-input-config.interface';

@Component({
    selector: 'app-time-range-input',
    templateUrl: './time-range-input.component.html',
    styleUrls: ['./time-range-input.component.scss'],
})
export class TimeRangeInputComponent implements OnInit {
    @Input() public formGroup: FormGroup;
    @Input() public inputId: string;
    @Input() public startTimePlaceholder: string = '';
    @Input() public endTimePlaceholder: string = '';
    @Input() public readonly: { start: boolean; end: boolean } = { start: false, end: false };

    @Output() public elementSizeModification = new EventEmitter<void>();

    public startTimeConfig: IBasicInputConfig = {
        inputId: '',
        placeholder: '',
        type: BasicInputTypeEnum.TIME,
    };

    public endTimeConfig: IBasicInputConfig = {
        inputId: '',
        placeholder: '',
        type: BasicInputTypeEnum.TIME,
    };

    public ngOnInit(): void {
        this.startTimeConfig.inputId = this.inputId + 'StartTime';
        this.startTimeConfig.placeholder = this.startTimePlaceholder;

        this.endTimeConfig.inputId = this.inputId + 'EndTime';
        this.endTimeConfig.placeholder = this.endTimePlaceholder;
    }

    public get startTime(): FormControl {
        return this.formGroup.get('start_time') as FormControl;
    }

    public get endTime(): FormControl {
        return this.formGroup.get('end_time') as FormControl;
    }
}
